import { createTheme } from "@mui/material/styles"

const stylesTheme = createTheme()

const getSpacing = (n) => Number.parseInt(stylesTheme.spacing(n).slice(0, -2), 10)

export const headerHeight = 72

export const multiLineNumRows = 6
export const smallMultiLineNumRows = 3

export const linkedinFill = "#0077b5"
export const facebookFill = "#3C5A99"

export const point93 = 0.93 // For opacity
export const point65 = 0.65 // For opacity

export const heroIconsSize = getSpacing(10) // stylesTheme.spacing(10) // 80

export const barChartHeight = getSpacing(40) // stylesTheme.spacing(40) // 320
export const descriptionHeight = getSpacing(30) //  stylesTheme.spacing(30) // 240

export const appContentWidth = 1400

export const dashboardMenuWidth = getSpacing(30) // stylesTheme.spacing(30)

export const { white } = stylesTheme.palette.common
export const { black } = stylesTheme.palette.common
export const { hover } = stylesTheme.palette.action
export const { selected } = stylesTheme.palette.action
export const white65 = `rgba(255,255,255,${point65})`
export const white93 = `rgba(255,255,255,${point93})`

// Root background, drawer backgrounds
export const gray50 = stylesTheme.palette.background.default

// BottomCard backgrounds, dividers
export const gray200 = stylesTheme.palette.grey["200"]

export const primaryTextColor = stylesTheme.palette.text.primary
export const disabledTextColor = stylesTheme.palette.text.disabled
export const secondaryTextColor = stylesTheme.palette.text.secondary

export const fillWhite = { fill: white }
export const fillFacebookFill = { fill: facebookFill }
export const fillLinkedInFill = { fill: linkedinFill }
export const fillDisabledTextColor = { fill: disabledTextColor }

export const errorRed = stylesTheme.palette.error.main // Error

export const colorErrorRed = { color: errorRed }
export const colorWhite = { color: white }
export const colorWhite65 = { color: white65 }
export const colorWhite93 = { color: white93 }
export const colorDisabledTextColor = { color: disabledTextColor }
export const colorSecondaryTextColor = { color: secondaryTextColor }
export const colorPrimaryTextColor = { color: primaryTextColor }

export const backgroundInherit = { background: "inherit" }
export const backgroundGray200 = { background: gray200 }
export const backgroundGray50 = { background: gray50 }
export const backgroundWhite = { background: white }
export const backgroundBlack = { background: black }
export const backgroundWhite65 = { background: white65 }
export const backgroundHover = { background: hover }
export const backgroundSelected = { background: selected }
export const backgroundSelectedImportant = {
  background: `${selected} !important`,
}

export const universalBorderStyle = `1px solid ${stylesTheme.palette.divider}`
export const borderTopUniversalBorderStyle = {
  borderTop: `1px solid ${stylesTheme.palette.divider}`,
}
export const borderBottomUniversalBorderStyle = {
  borderBottom: `1px solid ${stylesTheme.palette.divider}`,
}
export const borderNone = { border: "none" }

export const padding0 = { padding: stylesTheme.spacing(0) }
export const padding8 = { padding: stylesTheme.spacing(1) }
export const padding16 = { padding: stylesTheme.spacing(2) }
export const padding32 = { padding: stylesTheme.spacing(4) }
export const padding40 = { padding: stylesTheme.spacing(5) }
export const paddingTop0 = { paddingTop: stylesTheme.spacing(0) }
export const paddingTop8 = { paddingTop: stylesTheme.spacing(1) }
export const paddingTop16 = { paddingTop: stylesTheme.spacing(2) }
export const paddingRight0 = { paddingRight: stylesTheme.spacing(0) }
export const paddingRight8 = { paddingRight: stylesTheme.spacing(1) }
export const paddingRight16 = { paddingRight: stylesTheme.spacing(2) }
export const paddingBottom0 = { paddingBottom: stylesTheme.spacing(0) }
export const paddingBottom8 = { paddingBottom: stylesTheme.spacing(1) }
export const paddingBottom16 = { paddingBottom: stylesTheme.spacing(2) }
export const paddingBottom32 = { paddingBottom: stylesTheme.spacing(4) }
export const paddingBottom40 = { paddingBottom: stylesTheme.spacing(5) }
export const paddingLeft0 = { paddingLeft: stylesTheme.spacing(0) }
export const paddingLeft4 = { paddingLeft: stylesTheme.spacing(0.5) }
export const paddingLeft8 = { paddingLeft: stylesTheme.spacing(1) }
export const paddingLeft16 = { paddingLeft: stylesTheme.spacing(2) }
export const paddingLeft32 = { paddingLeft: stylesTheme.spacing(4) }
export const paddingLeft25Percent = { paddingLeft: "25%" } // Map sorry style

export const paddingBottom32Left32 = { ...paddingBottom32, ...paddingLeft32 }
export const subHeadlinePadding = { ...paddingBottom8, ...paddingTop16 } // Dialog

export const paddingTop0Bottom0 = { ...paddingBottom0, ...paddingTop0 }

export const sidePadding16 = { padding: stylesTheme.spacing(0, 2) }

export const padding8px16px = { padding: stylesTheme.spacing(1, 2) }
export const padding16px8px = { padding: stylesTheme.spacing(2, 1) }

export const paddingVertical8 = { padding: stylesTheme.spacing(1, 0) }
export const paddingVertical16 = { padding: stylesTheme.spacing(2, 0) }

export const borderRadius50Percent = { borderRadius: "50%" }
export const borderRadiusPure = getSpacing(0.5) // stylesTheme.spacing(0.5)
export const borderRadius = `${borderRadiusPure}px`
export const borderRadius4px = { borderRadius }
export const borderRadiusSidebar = {
  borderRadius: `${borderRadius} 0px 0px ${borderRadius}`,
}
export const borderbottomWidth0 = { borderBottomWidth: stylesTheme.spacing(0) }
export const linearProgressBorderRadius = {
  borderRadius: `${borderRadius} ${borderRadius} 0px 0px`,
}

export const avatarSmall = getSpacing(3) // stylesTheme.spacing(3) // 24
export const avatarMedium = getSpacing(6) // stylesTheme.spacing(6) // 48
export const avatarLarge = getSpacing(10) // stylesTheme.spacing(10) // 80
export const avatarExtraLarge = getSpacing(20) // stylesTheme.spacing(20) // 160
export const avatarEditorImage = getSpacing(40) // stylesTheme.spacing(40) // 320

export const avatarSmallSize = { height: avatarSmall, width: avatarSmall }
export const avatarMediumSize = { height: avatarMedium, width: avatarMedium }
export const avatarLargeSize = { height: avatarLarge, width: avatarLarge }
export const avatarExtraLargeSize = {
  height: avatarExtraLarge,
  width: avatarExtraLarge,
}
export const avatarEditorImageSize = {
  height: avatarEditorImage,
  width: avatarEditorImage,
}

export const avatarBackgroundHeight = getSpacing(20) // stylesTheme.spacing(20) // 160
export const avatarBackgroundWidth = getSpacing(100) // stylesTheme.spacing(100) // 800
export const avatarAdWidth = getSpacing(245) // stylesTheme.spacing(245) // 800
export const avatarAdHeight = getSpacing(56.5) // stylesTheme.spacing(56.5) // 800
export const avatarEditorBorder = 0

export const fontWeight400 = { fontWeight: 400 }
export const fontWeight500 = { fontWeight: 500 }
export const fontWeight600 = { fontWeight: 600 }

export const remPoint5 = ".5rem"
export const rem1Point5 = "1.5rem" // For social icons
export const remPoint875 = ".875rem"
export const rem3Point125 = "3.125rem"

export const fontSizePoint5rem = { fontSize: remPoint5 } // For recipient donation url quill
export const fontSizePoint875rem = { fontSize: remPoint875 } // For email quill icons
export const fontSize3Point125rem = { fontSize: rem3Point125 } // For Map Pin

export const margin0 = { margin: stylesTheme.spacing(0) }
export const margin16 = { margin: stylesTheme.spacing(2) }
export const marginNeg16 = { margin: stylesTheme.spacing(-2) }
export const marginLeft0 = { marginLeft: stylesTheme.spacing(0) }
export const marginLeft4 = { marginLeft: stylesTheme.spacing(0.5) }
export const marginLeft8 = { marginLeft: stylesTheme.spacing(1) }
export const marginLeft16 = { marginLeft: stylesTheme.spacing(2) }
export const marginBottom0 = { marginBottom: stylesTheme.spacing(0) }
export const marginBottom8 = { marginBottom: stylesTheme.spacing(1) }
export const marginBottom16 = { marginBottom: stylesTheme.spacing(2) }
export const marginRight0 = { marginRight: stylesTheme.spacing(0) }
export const marginRight4 = { marginRight: stylesTheme.spacing(0.5) }
export const marginRight8 = { marginRight: stylesTheme.spacing(1) }
export const marginRight16 = { marginRight: stylesTheme.spacing(2) }
export const marginTop0 = { marginTop: stylesTheme.spacing(0) }
export const marginTop4 = { marginTop: stylesTheme.spacing(0.5) }
export const marginTop8 = { marginTop: stylesTheme.spacing(1) }
export const marginTop16 = { marginTop: stylesTheme.spacing(2) }
export const marginTopNeg8 = { marginTop: stylesTheme.spacing(-1) } // For homepage header / mobile
// For homepage header / linearprogressdrawerstyle
export const marginTopNeg16 = { marginTop: stylesTheme.spacing(-2) }

export const marginTop16Bottom8 = { ...marginTop16, ...marginBottom8 }
export const marginTop8Bottom16 = { ...marginTop8, ...marginBottom16 }
export const bottomBarPadding = { margin: stylesTheme.spacing(2, 1, 1) } // "16px 8px 8px"
export const margin8px16px = { margin: stylesTheme.spacing(1, 2) }
export const margin16px8px = { margin: stylesTheme.spacing(2, 1) }
export const verticalMargin16 = { margin: stylesTheme.spacing(2, 0) }
export const verticalMargin40 = { margin: stylesTheme.spacing(5, 0) } // For suggested searches
export const horizontalMargin8 = { margin: stylesTheme.spacing(0, 1) }
export const horizontalMargin16 = { margin: stylesTheme.spacing(0, 2) }
// Sidebar hover, mobile suggested search
export const horizontalMarginNeg8 = { margin: stylesTheme.spacing(0, -1) }

export const userTaskTitle = { ...marginRight8, ...marginBottom16 }

export const maxWidth100Percent = { maxWidth: "100%" }
export const maxWidth60Percent = { maxWidth: "60%" } // used for listItemSecondaryAction
export const maxWidth72px = { maxWidth: 72 }
export const maxWidth110px = { maxWidth: 110 }
export const maxWidth120px = { maxWidth: 120 }
export const maxWidth240px = { maxWidth: 240 }
export const maxWidth360px = { maxWidth: 360 }
export const maxWidth480px = { maxWidth: 480 }
export const maxWidth560px = { maxWidth: 560 }
export const appContentMaxWidth = { maxWidth: appContentWidth }
export const maxWidthDashboardContainerDesktop = {
  maxWidth: `calc(100% - ${dashboardMenuWidth + getSpacing(2) - 98}px)`, // 100px less
}
export const maxWidthDashboardContainer = {
  // maxWidth: `calc(100% - ${dashboardMenuWidth + stylesTheme.spacing(2) + 2}px)`,
  maxWidth: `calc(100% - ${dashboardMenuWidth + getSpacing(2) + 2}px)`,
  // maxWidth: `calc(100% - ${dashboardMenuWidth + getSpacing(2) - 120}px)`,
  // [stylesTheme.breakpoints.down("sm")]: {
  //   maxWidth: `calc(100% - ${dashboardMenuWidth + getSpacing(2) + 2}px)`,
  // },
} // Weirdness with tables

export const width39Percent = { width: "39%" }
export const width50Percent = { width: "50%" } // Skeleton
export const width90Percent = { width: "90%" }
export const width100Percent = { width: "100%" } // Better than grow for footers
export const width24px = { width: 24 } // Zip Icon
export const width64px = { width: 64 }
export const width72px = { width: 72 }
export const width80px = { width: 80 }
export const width120px = { width: 160 } // Skeleton Job Post
export const width160px = { width: 160 } // Logo width
export const width240px = { width: dashboardMenuWidth }
export const width242px = {
  width: dashboardMenuWidth + 2,
} // Needed for weirdness on dashboardmenu
export const width320px = { width: 320 }
export const width400px = { width: 400 }
export const width480px = { width: 480 }
export const widthCalc100PercentSpacing4 = {
  width: `calc(100% + ${stylesTheme.spacing(4)})`,
}
export const widthCalc100PercentNeg240px = { width: "calc(100% - 240px)" }
export const widthCalc100PercentNeg30px = { width: "calc(100% - 30px)" }
export const widthInherit = { width: "inherit" }

export const headerCalc = `calc(100vh - ${headerHeight}px)`
export const headerCalcHeight = { height: headerCalc }
export const headerCalcMaxHeight = { maxHeight: headerCalc }

export const maxHeight320 = { maxHeight: 320 }
// FIXME: causing issues with map search results
export const maxHeightHeaderCalcSpacing4 = {
  maxHeight: `calc(100vh - ${headerHeight + getSpacing(4)}px`,
}
export const maxHeight100VH = { maxHeight: "100vh" }

export const minHeight40 = { minHeight: 40 }
export const minHeight80 = { minHeight: 80 }
export const minHeight120 = { minHeight: 120 }
export const minHeightAuto = { minHeight: "auto" }
export const minHeight100Percent = { minHeight: "100%" }

export const height16 = { height: 16 } // Linear progress height
export const height32 = { height: 32 } // Color picker, duration line
export const height64 = { height: 64 } // Small homepage hero
export const height72 = { height: 72 } // Needed for Wavelength logo
export const height80 = { height: 80 } // Homepage Hero avatar
export const height86 = { height: 86 } // Access requests
export const height160 = { height: 160 }
export const height320 = { height: 320 } // Email quill, wavelength avatar editor
export const height100Percent = { height: "100%" }

export const textAlignRight = { textAlign: "right" }

export const cursorPointer = { cursor: "pointer" }

export const textTransformNone = { textTransform: "none" }

export const whiteSpacePreLine = { whiteSpace: "pre-line" }
export const whiteSpaceNoWrap = { whiteSpace: "nowrap" }

export const displayNone = { display: "none" }
export const displayNoneImportant = { display: "none!important" } // For job list
export const displayBlock = { display: "block" } // For autosuggest suggestions

export const zIndexNeg100 = { zIndex: -100 } // BackgroundStyleBasic - map
export const zIndex100 = { zIndex: 100 }
export const zIndex800 = { zIndex: 800 }
export const zIndexAppBar = {
  zIndex: stylesTheme.zIndex.appBar,
} // 1100 for icon button cta, bottom bar, suggestions

export const boxShadowElevation2 = { boxShadow: stylesTheme.shadows["2"] } // Homepage hero

export const overflowHidden = { overflow: "hidden" }
export const overflowYHidden = { overflowY: "hidden" }
export const overflowYScroll = { overflowY: "scroll" }
export const overflowXAuto = { overflowX: "auto" }
export const overflowXHidden = { overflowX: "hidden" }

export const disablePointerEvents = { pointerEvents: "none" } // For tooltip purposes
export const pointerEventsAuto = { pointerEvents: "auto" } // For tooltip purposes

export const angle45 = { angle: 45 } // For network insights

export const flexAuto = { flex: "auto" }
export const flexShrink0 = { flexShrink: 0 }
export const flex1 = { flex: 1 }
export const flex110 = { flex: "1 1 0" }
export const flex00 = { flex: "0 0" }
export const flexDirectionRowReverse = { flexDirection: "row-reverse" }
export const flexWrapReverse = { flexWrap: "wrap-reverse" }
export const flexGrow1 = { flexGrow: 1 }

export const positionRelative = { position: "relative" }
export const positionAbsolute = { position: "absolute" }
export const positionSticky = { position: "sticky" }
export const positionFixed = { position: "fixed" }

export const transformY0 = { transform: "translateY(0)" }
export const transformYNeg20 = { transform: "translateY(-20%)" }

export const backgroundSize80Percent = { backgroundSize: "80%" }
export const backgroundSizeCover = { backgroundSize: "cover" }

export const typeEmail = { type: "email" }
export const typeTel = { type: "tel" }
export const typeUrl = { type: "url" }
export const autoCompleteOff = { autoComplete: "off" }

export const listStyleTypeNone = { listStyleType: "none" }

export const filterGrayscale1 = { filter: "grayscale(1)" }

export const wavelengthBackgroundImage = {
  backgroundImage: "url('/static/radio-background-2.png')",
}
export const getGradientBackground = (url) => ({
  backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0.60), rgba(0, 0, 0, 0.60)), url(${url})`,
})

export const boxSizingBorderBox = { boxSizing: "border-box" }
export const boxSizingContentBox = { boxSizing: "content-box" }

export const opacity25 = { opacity: 0.25 } // For filter icon
export const opacity65 = { opacity: point65 } // For sidebar whites as well
export const opacity93 = { opacity: point93 } // For sidebar whites as well
export const opacity1 = { opacity: 1 } // For map

export const top0 = { top: 0 }
export const top16 = { top: 16 }
export const topNeg40 = { top: -40 }

export const right0 = { right: 0 }
export const right16 = { right: 16 }
export const right24 = { right: 24 }

export const left0 = { left: 0 }
export const left8 = { left: 8 }
export const left16 = { left: 16 }
export const left120 = { left: 120 }
export const left496 = { left: 496 }

export const bottom0 = { bottom: 0 }
export const bottom40 = { bottom: 40 }

export const hoverStyle = { ...cursorPointer, "&:hover": backgroundHover }

export const getMuiToolBarRoot = (color) => ({
  background: `${color}`,
  ...borderBottomUniversalBorderStyle,
  ...sidePadding16,
})

export const getHeaderBoxShadow = (color) => ({
  ...padding16,
  [stylesTheme.breakpoints.down("md")]: { boxShadow: `inset 0px 2px ${color}` },
})

// These are done

// Sidebar
export const bottomSidebarLinkStyle = {
  ...paddingTop0Bottom0,
  ...colorWhite65,
}
export const sidebarNetworkList = {
  ...marginLeft8,
  ...borderRadiusSidebar,
  ...backgroundGray50,
  ...paddingVertical8,
}
export const nameStyle = { ...colorWhite93, ...paddingVertical8 }
export const logoWrapper = { ...padding16, ...height72, ...cursorPointer }
export const newLogoStyle = { ...width160px, ...opacity93 }
export const updateProfileStyle = { ...colorWhite93, ...marginTop8 }

// Map
export const simpleMapOverlayBaseStyle = {
  ...positionAbsolute,
  ...opacity65,
  ...zIndex100,
}
export const backgroundStyleBasic = {
  ...backgroundBlack,
  ...width100Percent,
  ...height100Percent,
  ...positionAbsolute,
  ...zIndexNeg100,
}
export const backgroundStyleDark = {
  ...backgroundStyleBasic,
  ...backgroundBlack,
}
export const backgroundStyleLight = {
  ...backgroundStyleBasic,
  ...backgroundWhite,
}
export const mapViewStyle = {
  ...headerCalcHeight,
  ...width100Percent,
  ...positionAbsolute,
  ...opacity65,
  ...zIndex800,
}
export const desktopSearchViewOuterDivStyle = {
  ...marginNeg16,
  ...positionAbsolute,
  ...headerCalcMaxHeight,
  ...widthCalc100PercentNeg240px,
}

// Search list
export const sizeToggleStyle = {
  ...boxSizingContentBox,
  ...positionAbsolute,
  ...top16,
  ...left496,
  ...zIndex800,
}
export const baseListStyle = {
  ...margin16,
  ...width100Percent,
  ...maxWidth480px,
  ...positionRelative,
  ...overflowYHidden,
  ...zIndex800,
  ...maxHeightHeaderCalcSpacing4,
  ...overflowYScroll,
}

// Bottom right cta
export const bottomRightCTAstyle = {
  ...width400px,
  ...zIndexAppBar,
  ...positionAbsolute,
  ...top16,
  ...right16,
}

// Quill
export const quillOutlinedStyle = { ...marginTop16Bottom8, ...height320 } // Rest of styles on css
export const toolbarStyle = { ...borderNone, ...padding0 }
export const selectQuillStyle = {
  ...padding8,
  ...borderRadius4px,
  ...maxWidth110px,
}

// Suggested search
export const mobileStyle = {
  ...horizontalMarginNeg8,
  ...padding8,
  ...marginTop16,
  ...positionRelative,
}

// Color picker
export const popover = { ...positionAbsolute, ...marginTop16, ...zIndex100 }
export const displayStyle = {
  ...height32,
  ...width80px,
  ...marginRight16,
  ...borderRadius4px,
}
export const cover = {
  ...positionFixed,
  ...top0,
  ...right0,
  ...bottom0,
  ...left0,
}

// Zoom Links
export const zoomHelperTextStyle = { ...cursorPointer, ...pointerEventsAuto }

// Edit contact info
export const zipIconStyle = {
  ...width24px,
  ...colorPrimaryTextColor,
  ...fontWeight500,
}
export const stickyRow = {
  ...positionSticky,
  ...top0,
  ...left0,
  ...backgroundGray50,
  ...zIndexAppBar,
}

// contact info
export const contactInfoDisplayText = {
  ...maxWidth60Percent,
  ...whiteSpacePreLine,
}

// Close button
export const searchIconButtonStyle = {
  ...positionAbsolute,
  ...top16,
  ...zIndex100,
}

// Avatar edit
export const avatarButtonStyle = { ...topNeg40, ...left120 }

// Wavelength image
export const wavelengthImageStyle = {
  ...avatarBackgroundHeight,
  ...avatarBackgroundWidth,
  ...borderRadius4px,
}
export const wavelengthBackgroundImageStyle = {
  ...wavelengthImageStyle,
  ...wavelengthBackgroundImage,
}

// AutosuggestUtil
export const suggestionsContainerOpen = {
  ...positionAbsolute,
  ...zIndexAppBar,
  ...left0,
  ...right0,
}
export const suggestionsList = {
  ...margin0,
  ...padding0,
  ...listStyleTypeNone,
}

// Social icons
export const linkedinimage = { ...fillLinkedInFill, ...cursorPointer }
export const facebookimage = { ...fillFacebookFill, ...cursorPointer }
export const disabled = { ...fillDisabledTextColor, ...colorDisabledTextColor }

// View as user
export const bottomBarStyleAbsolute = {
  ...positionAbsolute,
  ...bottom0,
  ...zIndexAppBar,
}

// Root styles
export const root = {
  ...positionRelative,
  ...margin0,
  ...minHeight100Percent,
  ...backgroundGray50,
}
export const leftSideIconStyle = { ...marginRight16, ...zIndex100 }
export const hero = {
  ...width100Percent,
  ...padding16,
  ...minHeight120,
  ...backgroundSizeCover,
  ...positionRelative,
  ...linearProgressBorderRadius,
}
export const avatar = {
  ...backgroundWhite,
  ...height80,
  ...width80px,
  ...borderRadius4px,
  [stylesTheme.breakpoints.down("sm")]: { ...height64, ...width64px, ...left8 },
  [stylesTheme.breakpoints.down("md")]: {
    ...height64,
    ...width64px,
    ...left16,
  },
}
export const rightSide = {
  [stylesTheme.breakpoints.up("sm")]: widthCalc100PercentNeg240px,
}
export const bodyRoot = {
  ...flexGrow1,
  [stylesTheme.breakpoints.up("md")]: {
    ...padding16,
    ...overflowYScroll,
    ...overflowXHidden,
  },
}
export const homepageHero = {
  ...padding16,
  ...borderRadius4px,
  ...backgroundSizeCover,
  ...positionRelative,
  [stylesTheme.breakpoints.up("md")]: marginTopNeg16,
  "&:hover": boxShadowElevation2,
}

// Avatar editor
export const customerBackgroundImg = {
  ...width480px,
  ...minHeight80,
  ...borderRadius4px,
}
export const customerSmallBackgroundImg = {
  ...width240px,
  ...minHeight40,
  ...borderRadius4px,
}

// Class note
export const imageStyle = { ...maxWidth100Percent, ...marginTop8Bottom16 }

// Dashboard -- needed for tables
export const dashboardPageStyle = {
  ...marginLeft16,
  ...maxWidthDashboardContainer,
}

// Recharts
export const chartMargins = {
  ...top0,
  ...right24,
  ...left0,
  ...bottom40,
}

// Activity
export const recentActionDivBase = { ...overflowYScroll, ...maxHeight320 }
export const recentActionDiv = { ...padding16, ...recentActionDivBase }

// Util
export const pageOuterStyle = { ...maxHeight100VH, ...overflowYScroll }
export const muiFormLabelRoot = { ...cursorPointer, ...textTransformNone }

// Sequence email page
export const durationPaperStyle = { ...padding16, ...verticalMargin16 }

// Job list
export const jobDescriptionStyle = {
  ...whiteSpacePreLine,
  ...marginTop8Bottom16,
}
export const jobPaperStyle = { ...padding16, ...marginBottom16 }

// Loading Job Post
export const loadingJobSiteButton = { ...maxWidth100Percent, ...width120px }

// Drawer
export const drawerStyle = {
  ...minHeightAuto,
  ...overflowYScroll,
  ...overflowXAuto,
  ...flex110,
  ...padding16,
}
export const drawerHeight = { ...minHeight100Percent, ...width100Percent }
export const drawerPaper = {
  ...maxWidth560px,
  ...width100Percent,
  ...backgroundGray50,
  ...borderNone,
}

// Ads
export const adStyle = { ...borderRadius4px, ...displayBlock }

// Linear progresses
export const dataBarSize = {
  ...height16,
  ...width80px,
  ...borderRadius4px,
  ...marginRight16,
}
export const linearProgressDrawerStyle = {
  ...widthCalc100PercentSpacing4,
  ...marginTopNeg16,
  ...marginBottom16,
  ...top0,
  ...zIndex100,
  ...positionSticky,
}
export const linearProgressStyle = {
  ...height16,
  ...linearProgressBorderRadius,
}

// These need work

// Access page drawer
export const possibleMatchOuter = {
  ...padding16,
  ...positionRelative,
  ...backgroundWhite,
}

// Import footers
export const csvNavBarStyle = { ...backgroundGray200, ...padding8px16px }
export const footer = {
  ...width100Percent,
  ...backgroundGray200,
  ...positionRelative,
  ...padding8px16px,
  ...borderTopUniversalBorderStyle,
  ...flexShrink0,
} // Like csv navbar
export const outerDivStyle = {
  ...backgroundGray200,
  ...borderTopUniversalBorderStyle,
  ...padding16,
}

export const dialogFormLabel = {
  ...width100Percent,
  ...marginTop16,
}

// Content Page - Default Image
export const contentPostNewDefaultImg = {
  ...widthCalc100PercentNeg30px,
  ...minHeight120,
  ...borderRadius4px,
}
export const contentPostDialogDefaultImg = {
  ...width100Percent,
  ...minHeight120,
  ...borderRadius4px,
}

export const styles = (theme) => ({
  backgroundColorPrimary50: { backgroundColor: theme.palette.primary[50] },
  fillColorPrimary500: { fill: theme.palette.primary[500] },
  backgroundColorPrimary800: { backgroundColor: theme.palette.primary[800] },
  width64px,
  hoverStyle,
  width242px,
  headerRoot: getHeaderBoxShadow(theme.palette.primary[800]),
  fontSize3Point125rem,
  homepageHero,
  jobDescriptionStyle,
  marginTop4,
  muiFormLabelRoot,
  customerSmallBackgroundImg,
  marginLeft8,
  hero,
  avatar,
  rightSide,
  bodyRoot,
  padding8px16px,
  bottomBarStyleAbsolute,
  appContentMaxWidth,
  maxWidth100Percent,
  verticalMargin40,
  maxWidth120px,
  colorDisabledTextColor,
  maxWidth60Percent,
  maxWidth240px,
  width50Percent,
  width90Percent,
  disablePointerEvents,
  height100Percent,
  searchIconButtonStyle,
  stickyRow,
  margin8px16px,
  marginTop8Bottom16,
  backgroundWhite65,
  backgroundStyleDark,
  backgroundStyleLight,
  bottomSidebarLinkStyle,
  sidebarNetworkList,
  whiteSpaceNoWrap,
  fillWhite,
  borderNone,
  cursorPointer,
  maxWidth360px,
  nameStyle,
  customerBackgroundImg,
  logoWrapper,
  newLogoStyle,
  mobileStyle,
  userTaskTitle,
  paddingVertical8,
  positionRelative,
  positionAbsolute,
  leftSideIconStyle,
  flexAuto,
  outerDivStyle,
  height32,
  durationPaperStyle,
  bottomRightCTAstyle,
  drawerStyle,
  drawerHeight,
  colorWhite,
  colorWhite93,
  colorWhite65,
  backgroundWhite,
  paddingLeft8Top8: { ...paddingLeft8, ...paddingTop8 },
  sidePadding16,
  paddingTop8,
  paddingTop16,
  paddingLeft8,
  paddingLeft16,
  paddingRight8,
  paddingRight16,
  padding8,
  padding16,
  paddingBottom0,
  paddingBottom8,
  paddingBottom16,
  paddingRight0,
  paddingLeft25Percent,
  grayscale: filterGrayscale1,
  marginTop16Bottom8,
  margin16,
  horizontalMargin16,
  marginBottom8,
  marginBottom16,
  marginLeft4,
  marginLeft16,
  marginTop0,
  marginTop8,
  marginTop16,
  marginRight8,
  marginRight16,
  marginTopNeg16,
  verticalMargin16,
  backgroundInherit,
  width80: width80px,
  width240: width240px,
  width320: width320px,
  imageStyle,
  contactInfoDisplayText,
  translateY0: transformY0,
  updateProfileStyle,
  recentActionDiv,
  recentActionDivBase,
  zIndex100,
  possibleMatchOuter,
  subHeadlinePadding,
  borderRadius4px,
  footer,
  colorErrorRed,
  width39Percent,
  suggestionsContainerOpen,
  displayBlock,
  suggestionsList,
  whiteSpacePreLine,
  root,
  linkedinimage,
  facebookimage,
  avatarSmallSize,
  avatarMediumSize,
  avatarLargeSize,
  avatarExtraLargeSize,
  avatarEditorImageSize,
  disabled,
  zIndex800,
  contentPostNewDefaultImg,
  contentPostDialogDefaultImg,
  maxWidth72px,
  width72px,
  // Map Legend Styles
  legendPaper: {
    ...padding16,
    ...positionAbsolute,
    ...top16,
    ...left16,
    ...zIndex800,
    ...backgroundWhite,
    ...borderRadius4px,
  },
  legendTitle: {
    ...marginBottom8,
    ...fontWeight500,
  },
  legendItem: {
    ...marginTop8,
  },
  legendIcon: {
    ...marginRight8,
    ...width24px,
  },
})
